<template>
    <!-- 86bc8uyd2: the Applicant Boost's identity step on the report dashboard.
         Styled like Shared/CardHeaderFooter's open step, but it launches Plaid
         identity verification in place instead of going to another page. -->
    <button
        type="button"
        class="block transition-transform hover:scale-105 h-full w-full text-left disabled:opacity-60"
        :disabled="busy"
        data-test="boost-identity-card"
        @click="$emit('start')"
    >
        <div class="flex flex-col divide-y divide-gray-200 overflow-hidden rounded-lg bg-white shadow cursor-pointer hover:shadow-lg w-full h-full border-l-4 border-blue-500">
            <div class="px-4 py-5 sm:px-6 flex justify-between">
                <div class="flex items-center">
                    <span class="flex items-center justify-center w-8 h-8 text-white text-sm font-bold rounded-full mr-3 bg-blue-600">
                        {{ step.number }}
                    </span>
                    <font-awesome-icon :icon="faIdCard" size="2x" class="mr-2" />
                    <span class="font-semibold">{{ step.name }}</span>
                </div>
                <div class="flex items-center">
                    <span class="hidden sm:inline-block bg-blue-600 text-white px-3 py-1 rounded-md text-xs font-medium mr-2">
                        {{ busy ? 'Starting...' : 'Verify Now' }}
                    </span>
                    <font-awesome-icon :icon="faLockOpen" size="2x" class="mr-2 text-gray-500" />
                </div>
            </div>
            <div class="flex-grow px-4 py-5 sm:p-6">{{ step.description }}</div>
        </div>
    </button>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faIdCard, faLockOpen } from '@fortawesome/pro-light-svg-icons'

export default {
    components: {
        FontAwesomeIcon,
    },
    props: {
        step: {
            type: Object,
            required: true,
        },
        busy: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['start'],
    setup() {
        return { faIdCard, faLockOpen }
    },
}
</script>
